export const repairActionTypes = {
    ADD_REPAIR_INFO: 'ADD_REPAIR_INFO'
}